export default __webpack_public_path__ + "static/Nail3-246cbb12c91287c8224a7ce1d3d50621.png";